import { render, staticRenderFns } from "./form-vacancies.vue?vue&type=template&id=07c70abc&"
import script from "./form-vacancies.vue?vue&type=script&lang=js&"
export * from "./form-vacancies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/forms/form-vacancies.vue
// module id = 1033
// module chunks = 0